// Any component can open the header's "schedule a visit" form without prop drilling.
export const SCHEDULE_VISIT_EVENT = 'cpr:schedule-visit';

export function openScheduleVisit(e) {
    if (e && e.preventDefault) {
        e.preventDefault();
    }
    window.dispatchEvent(new Event(SCHEDULE_VISIT_EVENT));
}
